export default  {
    component: 'mfm_param',
    name: 'mfm_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `Their are 2 options for module:
            - **live** 
            - **analytics**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **live** [Parameter Options : v1,v2,v3,ac_power,frequency,active_total_export_cumulative,active_total_import_cumulative]
            - **analytics** [Parameter Options : v1, v2, v3, v12, v23, v31, line_current_1, line_current_2, line_current_3, avg_power_factor, frequency, temperature, active_total_import_cumulative, active_total_export_cumulative, active_total_import, active_total_export, ac_power, reactive_power]`
          }
    ]
  }
